<template>
    <img
        v-if="logoType === 'dark'"
        class="app-logo"
        :src="require('@/assets/flex-logo.svg')"
        title="Toggle dark mode. Keyboard shortcut: CTRL + SHIFT + T."
        @dblclick="onDoubleClick"
    >

    <img
        v-else
        class="app-logo"
        :src="require('@/assets/flex-logo-white.svg')"
        title="Toggle dark mode. Keyboard shortcut: CTRL + SHIFT + T."
        @dblclick="onDoubleClick"
    >
</template>

<script>
import { mapState } from 'vuex';
import appThemes from '@/data/app-themes';

export default {
    name: 'app-logo',

    props: {
        themeSwitch: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        ...mapState({
            appTheme: state => state.page.appTheme,
            favorites: state => state.page.favorites,
            recents: state => state.page.recents,
        }),

        logoType() {
            return this.themeSwitch ? appThemes[this.appTheme].app.logo : 'light';
        },
    },

    methods: {
        onDoubleClick() {
            this.$emit('dblclick');
        },
    },
};
</script>
